// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    // eslint-disable-next-line no-undef
    $globalConfig = config;
}

const categoryConfig = {
    selectors: {
        catalogBreadcrumb: '#dinamic-category-breadcrumb-content',
    },
};
function init() {
    $(categoryConfig.selectors.catalogBreadcrumb).each((i, el) => {
        const $catalogBreadcrumb = $(el);
        initBreadcrumb($catalogBreadcrumb);
    });
}

function initBreadcrumb($catalogBreadcrumb) {
    const dataIds = $catalogBreadcrumb.attr('data-nav-id');
    const dataNames = $catalogBreadcrumb.attr('data-nav-name');
    const dataIdsList = dataIds && dataIds !== '' ? dataIds.split('#') : '';
    const dataNamesList = dataNames && dataNames !== '' ? dataNames.split('#') : '';
    const dataProductDivision = dataIdsList[1];
    const dataProduct = $catalogBreadcrumb.attr('data-nav-product') === 'product' || false;

    const $params = new URLSearchParams(window.location.search);
    // eslint-disable-next-line no-unused-vars
    const $category = $params.get('cat');

    if (dataNamesList !== '' && dataNamesList.length > 1) {
        let i = 1;
        let breadcrumbContent = '';
        dataNamesList.forEach((name) => {
            if (i !== 1 && i !== 4) {
                if (i === dataNamesList.length) {
                    if (dataProduct) {
                        if (i === 2) {
                            breadcrumbContent += `<a class="breadcrumb__child" href="${$globalConfig.urls.areaOfExpertiseOverviewHtml}?cat=${dataProductDivision}">${name}</a>`;
                        } else if (i === 3) {
                            breadcrumbContent += `<a class="breadcrumb__child" href="${$globalConfig.urls.areaOfExpertiseHtml}?cat=${dataIdsList[i - 1]}">${name}</a>`;
                        } else {
                            breadcrumbContent += `<a class="breadcrumb__child" href="${$globalConfig.urls.searchHtml}?cat=${dataIdsList[i - 1]}">${name}</a>`;
                        }
                    } else if (i === 2) {
                        breadcrumbContent += `<span class="breadcrumb__child">${name}</span>`;
                    } else {
                        breadcrumbContent += `<span class="breadcrumb__child">${name}</span>`;
                    }
                } else if (i === 2) {
                    breadcrumbContent += `<a class="breadcrumb__child" href="${$globalConfig.urls.areaOfExpertiseOverviewHtml}?cat=${dataProductDivision}">${name}</a><span class="breadcrumb__parent-icon icon-StateDark16"></span>`;
                } else if (i === 3) {
                    breadcrumbContent += `<a class="breadcrumb__child" href="${$globalConfig.urls.areaOfExpertiseHtml}?cat=${dataIdsList[i - 1]}">${name}</a><span class="breadcrumb__parent-icon icon-StateDark16"></span>`;
                } else {
                    breadcrumbContent += `<a class="breadcrumb__child" href="${$globalConfig.urls.categoryHtml}?cat=${dataIdsList[i - 1]}">${name}</a><span class="breadcrumb__parent-icon icon-StateDark16"></span>`;
                }
            }
            i++;
        });
        $catalogBreadcrumb.append(breadcrumbContent);
    }
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
